/*
 * @Author: Teemo Ding
 * @Date: 2021-09-09 16:11:10
 * @LastEditTime: 2021-10-20 17:17:18
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/request/stock/stock.ts
 */
import { get, post, remove } from 'src/tools/server';
import { ProductItem } from 'src/types/common/product';
import { Stock } from 'src/types/common/stock';
import { IGetProducts, StockListPage } from './types';

const getStocks = (startIndex, pageCount, body): Promise<IGetProducts> => {
  return post<IGetProducts>(
    `/portal/stocks/${startIndex || 0}/${pageCount || 10}`,
    body,
    {},
  );
};
const deleteStocks = (body): Promise<ProductItem[]> => {
  return remove<ProductItem[]>(`/portal/stocks`, body);
};
const stocksInit = (startIndex, pageCount, body): Promise<StockListPage> => {
  return post<StockListPage>(
    `/portal/stockListPage/${startIndex || 0}/${pageCount || 10}`,
    body,
    {},
  );
};
const postStock = (stock) => {
  return post('/portal/stock', stock, {});
};
const getStockPage = () => {
  return get('/portal/stockPage', {});
};

const getStockDetail = (stockUuid) => {
  return get<Stock>(`/portal/stock/${stockUuid}`, {});
};
export {
  getStocks,
  postStock,
  stocksInit,
  deleteStocks,
  getStockPage,
  getStockDetail,
};
